import {
  Control,
  FormState,
  UseFormGetValues,
  FieldValues,
  UseFormSetValue,
} from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import TextInput from '../../form/TextInput';
import PhoneInput from '../../form/PhoneInput';
import Name from '../../form/Name';
import Address from '../../form/Address';
import { StateCode } from '../../../data/models/state-code.model';
import validationUtils from '../../../services/validationUtils';
import addressUtils from '../../../services/addressUtils';
import { formClasses } from '../ElementDialog';
import { useCanEditBankInfo } from '../../../hooks/permissions/useCanEditBankInfo';

interface BillingInfoFormProps {
  control: Control;
  formState: FormState<any>;
  requiredFieldMessage: string;
  stateCodes: StateCode[];
  getValues: UseFormGetValues<FieldValues>;
  setValue: UseFormSetValue<any>;
}

export default function BillingInfoForm({
  control,
  formState,
  requiredFieldMessage,
  stateCodes,
  getValues,
  setValue,
}: BillingInfoFormProps) {
  const { t } = useTranslation('common');
  const canEditBankInfo = useCanEditBankInfo();

  const copyDispatchAddress = (evt: any) => {
    evt.preventDefault();
    addressUtils.copyDispatchToBilling(getValues(), setValue);
  };

  return (
    <>
      <Name
        namePrefix="BillingContact"
        control={control}
        formState={formState}
        requiredFieldMessage={requiredFieldMessage}
        firstNameLabel={t('provider.contactFirst') || ''}
        lastNameLabel={t('provider.contactLast') || ''}
      />
      <TextInput
        label={t('provider.billingEmail')}
        name="BillingEmailAddress"
        required={true}
        control={control}
        errors={formState.errors}
        rules={{
          required: requiredFieldMessage,
          pattern: validationUtils.emailValidation(),
        }}
        inputProps={{ maxLength: 255 }}
      />
      <Button
        href="#"
        className={formClasses.copy}
        variant="contained"
        color="secondary"
        onClick={copyDispatchAddress}>
        {t('provider.copyDispatchAddress')}
      </Button>
      <Address
        namePrefix="Billing"
        control={control}
        formState={formState}
        requiredFieldMessage={requiredFieldMessage}
        stateCodes={stateCodes}
      />
      <PhoneInput
        label={t('provider.billingPhone')}
        name="BillingPhone"
        extensionName="BillingPhoneExtension"
        required={true}
        control={control}
        errors={formState.errors}
      />
      <TextInput
        label={t('provider.bankName')}
        name="BankName"
        required={false}
        control={control}
        errors={formState.errors}
        inputProps={{ maxLength: 200 }}
      />
      <TextInput
        label={t('provider.bankRoutingNumber')}
        name="BankRoutingNumber"
        required={false}
        disabled={!canEditBankInfo}
        control={control}
        errors={formState.errors}
        inputProps={{ maxLength: 15 }}
        // TODO: took this out for now. Need to deal with obfuscated values because they aren't all numeric
        // rules={{
        //   pattern: validationUtils.accountNumberValidation(
        //     t,
        //     'common.invalidRoutingNumber',
        //   ),
        // }}
      />
      <TextInput
        label={t('provider.bankAccountNumber')}
        name="BankAccountNumber"
        required={false}
        disabled={!canEditBankInfo}
        control={control}
        errors={formState.errors}
        inputProps={{ maxLength: 20 }}
        // TODO: took this out for now. Need to deal with obfuscated values because they aren't all numeric
        // rules={{
        //   pattern: validationUtils.accountNumberValidation(
        //     t,
        //     'common.invalidAccountNumber',
        //   ),
        // }}
      />
    </>
  );
}
